import * as React from "react";

interface IProps {
    id?: string;
    value: string | number | boolean;
    children?: React.ReactNode[] | React.ReactNode;
}

class ToggleOption extends React.Component<IProps> {
    constructor(props: IProps) {
        super(props);
    }

    public render() {
        return (
            <div>
                {this.props.children}
            </div>
        );
    }
}

export default ToggleOption;


// WEBPACK FOOTER //
// ./src/Components/ToggleBar/ToggleOption/ToggleOption.tsx